import { EyeIcon } from "@heroicons/react/outline";
import Button from "components/button";
import { Modal } from "components/modal";
import { useMemo, useState } from "react";

interface HtmlPreviewButtonProps {
  html?: string;
  title?: string;
}

const EMPTY_PREVIEW_HTML = `
<div style="padding:24px;font-family:Arial,sans-serif;color:#6b7280;">
  No HTML to preview.
</div>
`;

export const buildTailwindPreviewHtml = (html = "") => `
<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src https://cdn.tailwindcss.com 'unsafe-eval'; style-src 'unsafe-inline'; img-src data: blob: https:; font-src data: https:;" />
    <script src="https://cdn.tailwindcss.com"></script>
    <style>
      body {
        margin: 0;
        min-height: 100vh;
        background: #ffffff;
      }
    </style>
  </head>
  <body>
    ${html.trim() ? html : EMPTY_PREVIEW_HTML}
  </body>
</html>
`;

export const HtmlPreviewButton = ({
  html = "",
  title = "HTML preview",
}: HtmlPreviewButtonProps) => {
  const [open, setOpen] = useState(false);
  const previewHtml = useMemo(() => buildTailwindPreviewHtml(html), [html]);

  return (
    <>
      <Button
        type="button"
        className="w-fit px-3 py-1.5 text-xs bg-white text-brand-500 border border-solid border-brand-500 shadow-none hover:bg-gray-50 active:bg-gray-100"
        onClick={() => setOpen(true)}
      >
        <EyeIcon className="mr-1.5 h-4 w-4 shrink-0" />
        <span className="shrink-0">Preview</span>
      </Button>
      <Modal title={title} open={open} onClose={() => setOpen(false)}>
        <div className="w-[calc(100vw-2rem)] max-w-full p-4 sm:w-[900px]">
          <iframe
            title={title}
            srcDoc={previewHtml}
            sandbox="allow-scripts"
            className="h-[60vh] min-h-[360px] w-full rounded-md border border-solid border-gray-200 bg-white"
          />
        </div>
      </Modal>
    </>
  );
};
